const conversaContatoMotivos = {
  PROSPECCAO: 1,
  AGENDAMENTO: 2,
  NEGOCIACAO: 3,
  COMUNICACAO: 4,
  PESQUISA_SATISFACAO: 5,
  COBRANCA: 6,
}

export { conversaContatoMotivos }
